// Description: Page that will allow the new users to create an account
// Updated: 02/07/2025
// Author: Simon Franklin

// React
import React, { useState } from "react";

import { useLocation } from "react-router-dom";

import { Box, useMediaQuery } from "@mui/material";

import Logo from "../../assets/ilustrations/Logo";
import "./styles.css";
import Form from "./Form";
import { AuthSignup } from "../../api/aws/Auth/Signup";
import MobileForm from "./MobileForm";

// Render The Component
const SignUp = () => {
    // State Variables
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const isSmallScreen = useMediaQuery("(max-width:600px)");

    const location = useLocation();
    const messageParams = location.state ? location.state.message : "";
    const [message, setMessage] = useState(messageParams ? messageParams : "");

    const [checked, setChecked] = React.useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleNotify = (returnMessage) => {
        if (returnMessage.includes("Field")) {
            setMessage("Preencha todos os campos.");
        } else if (returnMessage === "Username already exists") {
            setMessage("Esse nome de usuário já existe.");
        } else if (returnMessage === "Email already exists") {
            setMessage("Esse e-mail já foi cadastrado.");
        } else if (returnMessage === "Email or username already exists") {
            setMessage("E-mail ou nome de usuário já existem.");
        } else if (returnMessage === "Invalid credentials") {
            setMessage("Credenciais inválidas.");
        } else if (returnMessage === "Password must be at least 8 characters long") {
            setMessage("A senha precisa ter no mínimo 8 caracteres.");
        } else if (returnMessage === "Password must contain at least 1 number") {
            setMessage("A senha precisa conter pelo menos 1 número.");
        } else if (returnMessage === "Password must contain at least 1 uppercase letter") {
            setMessage("A senha precisa conter pelo menos 1 letra maiúscula.");
        } else if (returnMessage === "Password must contain at least 1 lowercase letter") {
            setMessage("A senha precisa conter pelo menos 1 letra minúscula.");
        } else if (returnMessage === "An unexpected error occurred") {
            setMessage("Ocorreu um erro inesperado. Tente novamente mais tarde.");
        }
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!username || !password) {
            setMessage("Por favor, preencha todos os campos.");
            return;
        }

        if (password !== confirmPassword) {
            setMessage("As senhas não estão iguais.");
            return;
        }

        setLoading(true);

        try {
            const response = await AuthSignup({ username, password, confirmPassword, email });

            if ((response.status || response.message) === "success" && response.accessToken) {

                // Limpa cookies indesejados
                document.cookie.split(";").forEach((cookie) => {
                    const cookieName = cookie.split("=")[0].trim();
                    if (!["_chatwoot_session", "cw_conversation"].includes(cookieName)) {
                        document.cookie = `${cookieName}=;expires=${new Date().toUTCString()};path=/; SameSite=None; Secure`;
                    }
                });

                // Armazena o token no localStorage
                const expirationTime = Date.now() + 30 * 60 * 1000;
                localStorage.setItem("expiration_time", expirationTime);
                localStorage.setItem("jwt_token", response.accessToken);
                localStorage.setItem("idToken", response.idToken);
                localStorage.setItem("refreshToken", response.refreshToken);

                window.location.href = "/";

            } else {
                handleNotify(response.message || "Erro inesperado. Tente novamente mais tarde.");
            }
        } catch (error) {
            handleNotify(error.message)
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {isSmallScreen ? (
                <MobileForm
                    username={username}
                    setUsername={setUsername}
                    password={password}
                    setPassword={setPassword}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                    email={email}
                    setEmail={setEmail}
                    message={message}
                    loading={loading}
                    checked={checked}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setMessage={setMessage}
                />
            ) : (
                <>
                    <div
                        style={{
                            position: "absolute",
                            top: "20px",
                            left: "20px",
                            padding: "10px",
                        }}
                    >
                        <Logo />
                    </div>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: { xs: "start", lg: "center" },
                            height: "100vh",
                            background: 'linear-gradient(135deg, #ffffff 0%, #EDE8FF 100%)',
                        }}
                    >
                        <Form
                            username={username}
                            setUsername={setUsername}
                            password={password}
                            setPassword={setPassword}
                            confirmPassword={confirmPassword}
                            setConfirmPassword={setConfirmPassword}
                            email={email}
                            setEmail={setEmail}
                            message={message}
                            loading={loading}
                            checked={checked}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setMessage={setMessage}
                        />
                    </Box>
                </>
            )}
        </>
    );
};

export default SignUp;